import React from "react";
import TextField from "@mui/material/TextField";

export function Textfield(props) {
    return <TextField {...props}/>
}